<template>
<div>
  <ul class="news-ul" v-show="!this.$store.state.isMobile">
		<li class="news-item" v-for="(item,index) in news" :key="index" @click="click(item)">
			<a target="_blank"  :href="item.newsUrl">
			<div class="top" :style="{backgroundImage:'url('+ item.covers +')'}">
				<!-- <img :src="item.img" alt=""> -->
			</div>
			<div class="news-title">{{item.title}}</div>
			<div class="time"><span>{{item.showTime}}</span><span>{{item.showName}}</span></div>
			<div class="rows" v-html="item.newsSummary"></div>
			</a>
		</li>
	</ul>
    <el-row :span="24" class="news-ul" v-show="this.$store.state.isMobile">
      <el-col
        :xs="24"
        :sm="8"
        :md="8"
        :lg="8"
        :xl="8"
        class="news-item"
        v-for="(item,index) in news"
        :key="index"
        @click="click(item)"
      >
        <a target="_blank" :href="item.newsUrl">
          <div class="top" :style="{backgroundImage:'url('+ item.covers +')'}"></div>
          <div class="news-item-line"></div>
          <div class="news-title">{{item.title}}</div>
          <div class="time">
            <span>{{item.showTime}}</span>
            <span>{{item.showName}}</span>
          </div>
          <div class="rows" v-html="item.newsSummary"></div>
        </a>
      </el-col>
    </el-row>
</div>
</template>

<script>
export default {
  props: {
    news: {
      type: Array
    }
  },
  data() {
    return {
	  // newsData: []
	  isMobile: false
    };
  },
  computed: {
	isMobile: {
		get() {
			console.log(this.$store.state.isMobile)
			return this.$store.state.isMobile;
		}
	}
},
  mounted() {
  },
  methods: {
    click(item) {
      let src = item.title;
      this.$uweb.trackEvent(src, "点击");
    }
  },
  computed: {}
};
</script>
<style rel="stylesheet/scss" lang="scss">
@import "@/assets/css/variables.scss";
.news-ul {
  width: 1230px;
  margin-left: -30px;
  overflow: hideen;
  margin-bottom: 100px;
  .news-item {
    width: 380px;
    float: left;
    margin-left: 30px;
    .top {
      border-bottom: 6px solid $color-primary;
      width: 380px;
      height: 240px;
      overflow: hidden;
      background-position: center center;
      // background-position: center center;
      background-repeat: no-repeat;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      background-size: cover;
      box-sizing: border-box;
      justify-content: space-around;
      align-content: center;
      margin: 2px;
    }
    .news-title {
      font-size: 18px;
      color: $color-primary;
      line-height: 25px;
      margin-top: 10px;
    }
    .time {
      margin-top: 10px;
      margin-bottom: 5px;
      span {
        color: rgba(174, 149, 79, 1);
        margin-right: 10px;
      }
    }
    .rows {
      font-size: 14px;
      color: #666666;
      line-height: 24px;
    }
  }
}
@media (max-width: 768px) {
  .news-ul {
	width: 100%;
	margin: 0;
    .news-item {
	  margin: 0;
	  width: 100%;
	  box-sizing: border-box;
	  padding: 0 4%;
	  padding-bottom: 32px;
	  .news-item-line {
		  width: 100%;
		  height: 4px;
		  background: #003478;
	  }
      .top {
        border-bottom: none;
        width: 100%;
		height: 216px;
    margin: 0;
		margin-bottom: 3px;
        overflow: hidden;
		background-position: center center;
        background-repeat: no-repeat;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        background-size: cover;
        box-sizing: border-box;
        justify-content: space-around;
        align-content: center;
      }
      .news-title {
		margin-top: 15px;
		width: 100%;
		box-sizing: border-box;
		padding-left: 7px;
		font-size:18px;
		line-height: 18px;
		font-family:SourceHanSansCN-Medium;
		font-weight:500;
		text-align: left;
      }
      .time {
        margin-top: 10px;
		margin-bottom: 16px;
		text-align: left;
		width: 100%;
		box-sizing: border-box;
		padding-left: 7px;
		line-height:10px;
        span {
			font-size:11px;
			font-family:SourceHanSansCN-Regular;
			font-weight:400;
          color: rgba(174, 149, 79, 1);
          margin-right: 10px;
        }
      }
      .rows {
		  width: 100%;
		box-sizing: border-box;
		padding-left: 5px;
        font-size: 13px;
        color: #666666;
		line-height: 17px;
		font-size:13px;
		font-family:SourceHanSansCN-Regular;
		font-weight:400;
		text-align: left;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/news/news.vue